// extracted by mini-css-extract-plugin
export default {"description":"wJ07","times":"g2Gl","grid":"_2YwJ","title":"drb9","bigTitle":"_2oxr","bigNumber":"_3OPG","split":"YCwf","main":"_3G4M","line":"_3Z2l","twoColumn":"_3iGF"};